import { Injectable, NgZone } from "@angular/core";
import { DatacontextService } from "src/app/data/datacontext.service";
import { CommonNotificationService } from "../common-notification/common-notification.service";
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";

declare var Hansel: any;

@Injectable({
  providedIn: "root"
})
export class WebSdkService {
  public sdkReady: boolean;
  private sdkPending: boolean;
  private appId: string;
  private appKey: string;

  constructor(
    private datacontextService: DatacontextService,
    private commonNotificationService: CommonNotificationService,
    private router: Router,
    private zone: NgZone,
    public snackbar: MatSnackBar
  ) {
    this.setupKeys();
  }

  private setupKeys() {
    // production app details
    //  app name => workspace-prod; domain name => hansel.io; account => Morphic Params
    if (location.hostname === "workspace.hansel.io") {
      this.appId = "9W2GLUULN7K55N9HCZOTWWL37";
      this.appKey = "UPS0ME9703FSDXQNJSL9LGA7FLKXBFYNA9PCW1U4FNU3S1E6CV";
    } else {
      // test app details
      // app name => worspace-testenv; domain name => hansel.io; account => Morphic Params
      this.appId = "NMCV13OF5JTI6EMKT4D2BBZCG";
      this.appKey = "PLR4GJYOPO2UMQVKATJZBAGFNKKLKSANLX635MR6998AKRVI3U";
    }

    // this.appId = "9W2GLUULN7K55N9HCZOTWWL37";
    // this.appKey = "UPS0ME9703FSDXQNJSL9LGA7FLKXBFYNA9PCW1U4FNU3S1E6CV";
  }

  private connect() {
    // cancel if a connection is already in progress
    if (this.sdkPending) {
      return new Promise<any>(resolve => { });
    }
    this.sdkPending = true;
    const connectionPromise = new Promise<boolean>((resolve, reject) => {
      try {
        Hansel.initialize(this.appId, this.appKey, () => {
          this.sdkReady = true;
          this.sdkPending = false;
          this.setupActionListeners();
          resolve(this.sdkReady);
        });
      } catch (error) {
        this.sdkReady = false;
        this.sdkPending = false;
        reject(this.sdkReady);
      }
    });

    return connectionPromise;
  }

  public getData(type: string, key: string, fallback: any): Promise<any> {
    const promise = new Promise<any>(resolve => {
      // if connection has already been establised
      if (this.sdkReady) {
        try {
          resolve(this.getSDKMethod(type)(key, fallback));
        } catch (error) {
          resolve(fallback);
        }
      } else {
        this.connect()
          .then((status: boolean) => {
            resolve(this.getSDKMethod(type)(key, fallback));
          })
          .catch(er => {
            resolve(fallback);
          });
      }
    });

    return promise;
  }

  private getSDKMethod(type: string) {
    switch (type) {
      case "string":
        return Hansel.getString;
      case "number":
        return Hansel.getNumber;
      case "boolean":
        return Hansel.getBoolean;
      case "JSON":
        return Hansel.getJSON;
    }
  }

  private setupActionListeners() {
    const listeners = [
      {
        name: "requestPlanUpgrade",
        callback: this.requestPlanUpgrade
      },
      {
        name: "createAppListener",
        callback: this.handleCreateApp
      }
    ];

    listeners.forEach(action => {
      Hansel.registerAction(action.name, action.callback);
    });
  }

  private handleCreateApp = () => {
    let routeData: any = {
      href: "/settings",
      queryParams: { createApp: true }
    };
    this.router
      .navigate([routeData.href], { queryParams: routeData.queryParams })
      .catch(err => {
        // Handle here
        window.history.pushState(
          {},
          document.title,
          routeData.href +
          (routeData.queryParams ? this.serialize(routeData.queryParams) : "")
        );
        window.location.reload();
      });
  };

  serialize(obj) {
    const str = [];
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
    return str.join("&");
  }

  private requestPlanUpgrade = () => {
    this.datacontextService.misc
      .sendEmail("request_pro_upgrade")
      .subscribe((data: any) => {
        // setTimeout(() => {
        if (data.is_error) {
          this.showSnackBar(
            "Error occurred while logging your request for account upgrade. " +
            "Please contact us via chat or email options.",
            "error",
            2000
          );
        } else {
          this.showSnackBar(
            "Your account upgrade request has been logged. " +
            "Our sales team will get in touch with you soon.",
            "success",
            2000
          );
        }
        // }, 1000);
      });
  };

  private showSnackBar = (
    message,
    type: "default" | "error" | "success" | "warn",
    durationInMs,
    action?: string
  ) => {
    const config = new MatSnackBarConfig();
    (config.duration = durationInMs ? durationInMs : 2000),
      (config.verticalPosition = "top");
    config.horizontalPosition = "center";
    config.panelClass = type;
    this.zone.run(() => {
      this.snackbar.open(message, action, config);
    });
  };
}
